import { svg } from "lit";
const icon = svg `<path d="M9.59396 32.0727H15.7799V21.9659H24.22V32.0727H30.406V16.4637L20 8.62185L9.59396 16.4602V32.0727ZM7.5 34.1667V15.4168L20 6.00977L32.4999 15.4168V34.1667H22.126V24.0599H17.8739V34.1667H7.5Z" fill="currentColor"/>`;
export default icon;
